<template>
    <div id="comments">        
        <div class="box">
            <h1 id="title" class="title has-text-grey-dark"><i class="fa fa-paper-plane"></i> Save time by using templates</h1>
            <p class="subtitle">Combine sentences and create new and unique feedback</p>
        </div>
        <!--<hr>-->
        <div class="columns is-multiline">
            <div class="column">
                <div id="tabs" class="tabs is-toggle is-fullwidth">
                    <ul class="box">
                        <li v-bind:class="{'is-active': step==1}" @click="changeStep(1)">
                            <a>
                            <span class="icon is-small"><i class="fa fa-cogs"></i></span>
                            <span>New Feedback</span>
                            </a>
                        </li>
                        <li v-bind:class="{'is-active': step==2}" @click="changeStep(2)">
                            <a>
                            <span class="icon is-small"><i class="fa fa-star"></i></span>
                            <span>Choose Template</span>
                            </a>
                        </li>
                        <li v-bind:class="{'is-active': step==3}" @click="changeStep(3)">
                            <a>
                            <span class="icon is-small"><i class="fa fa-history"></i></span>
                            <span>Choose From History</span>
                            </a>
                        </li>
                    </ul>
                </div>
                <transition name="fade">
                    <div v-show="step == 1">
                        <div class="box"   data-tour-com-step="3">
                            <div class="columns is-multiline" ref="leesonInfo">
                                <div class="column is-12 control" v-if="me && me.profile && me.profile.schools && me.profile.schools.length > 1"  data-tour-com-step="3">
                                    <span class="heading has-text-grey-dark">School</span>
                                    <div class="field has-addons">
                                        <p class="control" v-for="(school, index) in me.profile.schools">
                                            <a href="javascript:{}" @click="selectSchool(school)" class="button" v-bind:class="{'is-selected is-primary': school.id == me.profile.school.id }">{{school.name}}</a>
                                        </p>
                                    </div>
                                </div>

                                <div class="column is-3-fullhd is-3-widescreen is-12-mobile is-4-tablet" v-if="me.profile.school.name != ITUTOR.name">
                                    <div class="field">
                                        <span class="heading has-text-grey-dark">Lesson ID
                                            <a v-if="me.profile && me.profile.school" class="is-link is-pulled-right tooltip is-tooltip-multiline is-tooltip-bottom" data-tooltip="Please input the unique lesson ID number associated with this lesson. If the lesson is already added Lesson name and Vocabulary will be filled out automatically. Otherwise, please add it manually and it'll be saved for future use. You will find this unique ID on your schools website!"><i class="fa fa-question-circle is-size-5"></i></a>
                                            <a v-else class="is-link is-pulled-right tooltip is-tooltip-multiline is-tooltip-bottom" data-tooltip="In order to unlock this feature, please go to Profile page and select your school."><i class="fa fa-question-circle is-size-5"></i></a>
                                        </span>
                                        <!--<bulma-input type="text" name="lessonID" v-model="lesson.provider_id" v-bind:disabled="!me.profile || !me.profile.school" rules="" placeholder='Copy it from your schools website'/>-->
                                        <search-select  v-bind:disabled="!me.profile || !me.profile.school"
                                                       reference="searchLessonSelectPID"
                                                       label="provider_id"
                                                       optionText="Existing lesson"
                                                       :placeholder="lessonPlaceholder"
                                                       :selected="lesson"
                                                       :items="lessonsPID"
                                                       :loading="searchLessonPID"
                                                       @change="onLessonChangedPID"
                                                       @type="onLessonTypePID">
                                        </search-select>
                                        <span class="help">{{ lessonFormatHint }}</span>
                                        <span class="help is-danger">{{ lessonError }}</span>
                                    </div>
                                </div>
                                <div class="column is-3-fullhd is-3-widescreen is-12-mobile is-4-tablet">
                                    <div class="field">
                                        <span class="heading has-text-grey-dark">Lesson name</span>
                                        <search-select v-bind:disabled="!me.profile || !me.profile.school"
                                                       reference="searchLessonSelect"
                                                       label="name"
                                                       optionText="Existing lesson"
                                                       placeholder="e.g. Alphabet AB"
                                                       :selected="lesson"
                                                       :items="lessons"
                                                       :loading="searchLesson"
                                                       @change="onLessonChanged"
                                                       @type="onLessonType">
                                        </search-select>
                                    </div>
                                </div>
                                <div class="column is-3-fullhd is-3-widescreen is-12-mobile is-4-tablet">
                                    <div class="field">
                                        <span class="heading has-text-grey-dark">Vocabulary</span>
                                        <input type="text" name="words" v-model="lesson.words" placeholder='e.g. book, cow, chicken... '  :class="{'input': true, 'is-danger': wordsRequired }" />
                                        <transition name="fade-fast">
                                            <span v-show="wordsRequired" class="help is-danger">Lesson vocabulary is required</span>
                                        </transition>
                                    </div>
                                </div>
                            </div>
                            <div class="columns is-multiline">
                                <div class="column is-3-fullhd is-4-widescreen is-12-mobile is-4-tablet"  v-if="me.profile.school.name != ITUTOR.name">
                                    <div class="field">
                                        <span class="heading has-text-grey-dark">Student ID
                                            <a v-if="me.profile && me.profile.school" class="is-link is-pulled-right tooltip is-tooltip-multiline is-tooltip-bottom" data-tooltip="Please input the unique Student ID associated with this student. If the student is already in our database the Student Name and Gender will fill out automatically and you'll be able to track student's progress via feedback history. You will find this unique ID on your schools website!"><i class="fa fa-question-circle is-size-5"></i></a>
                                            <a v-else class="is-link is-pulled-right tooltip is-tooltip-multiline is-tooltip-bottom" data-tooltip="In order to unlock this feature, please go to Profile page and select your school."><i class="fa fa-question-circle is-size-5"></i></a>
                                        </span>
                                        <bulma-input v-bind:disabled="!me.profile || !me.profile.school" type="text" name="studentID" v-model="student.provider_id" rules="" placeholder='e.g. 134653'/>
                                        <span class="help is-danger">{{ studentError }}</span>
                                    </div>
                                </div>
                                <div class="column is-3-fullhd is-4-widescreen is-12-mobile is-4-tablet">
                                    <div class="field">
                                        <span class="heading has-text-grey-dark">Student name <span class="has-text-danger"><b>*</b></span></span>
                                        <input type="text" name="studentName" v-model="student.name" rules="" placeholder='e.g. Jason' :class="{'input': true, 'is-danger': studentRequired }"/>
                                        <transition name="fade-fast">
                                            <span v-show="studentRequired" class="help is-danger">Student name is required</span>
                                        </transition>
                                    </div>
                                </div>
                                <div class="column is-2-fullhd is-4-widescreen is-12-mobile is-4-tablet">
                                    <div class="field">
                                        <span class="heading has-text-grey-dark has-text-centered">Gender</span>
                                        <div class="control has-text-centered">
                                            <label>
                                                <input type="radio" class="option-input radio" value="male" name="gender" v-model="student.gender" @change="genderChanged">
                                                <span>Male</span>
                                            </label>
                                            <label>
                                                <input type="radio" class="option-input radio" value="female" name="gender" v-model="student.gender" @change="genderChanged">
                                                <span>Female</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="columns is-multiline">
                                <div v-for="(item, index) in activeMagicWords" class="column is-3-fullhd is-4-widescreen is-12-mobile is-4-tablet">
                                    <div class="field">
                                        <span class="heading has-text-grey-dark">{{item.title}} <span class="has-text-danger"><b></b></span></span>
                                        <input v-if="item.type === 'input'" :class="{'input': true, 'is-danger': errors.has(item.name) }"  v-validate="'required'" type="text" :name="item.name" v-model="magicWordsData[item.name]" :placeholder="item.placeholder" v-on:input="magicWordsDataChanged()"/>
                                        <textarea v-else :class="{'is-primary textarea': true, 'is-danger': errors.has(item.name) }"  :name="item.name" v-validate="'required'" v-model="magicWordsData[item.name]" :placeholder="item.placeholder" v-on:input="magicWordsDataChanged()"/>
                                        <transition name="fade-fast">
                                            <span v-show="errors.has(item.name)" class="help is-danger">This field is required</span> <!--{{ errors.first(item.name) }}-->
                                        </transition>
                                    </div>
                                </div>
                            </div>
                            <div class="columns" v-if="studentComments && studentComments.length > 0">
                                <div class="column">
                                    <a href="javascript:{}" class="heading is-link is-size-6" @click="showStudentsModal = true"><u>You gave feedback to this student before, click here to see what you wrote.</u></a>
                                </div>
                            </div>
                        </div>
                        <div class="columns is-multiline box">
                            <div class="column is-12">
                                <div class="field p5"  data-tour-com-step="4">
                                    <span id="filters" class="heading has-text-grey-dark">Apply filter</span>
                                    <div class="control has-icons-left has-icons-right">
                                        <input id="sentence" class="is-primary" name="sentence" v-model="sentence"  v-validate=""  v-bind:class="{'input': true, 'is-danger': errors.has('sentence') }"
                                            type="text" 
                                            placeholder="Start typing sentence..."></input>
                                        <transition name="fade-fast">
                                            <span v-show="errors.has('sentence')" class="help is-danger">{{ errors.first('sentence') }}</span>
                                        </transition>
                                        <span class="icon is-small is-left">
                                        <i class="fa fa-search" v-if='!searching'></i>
                                        <i class="fas fa-spinner fa-spin" v-else></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="column" data-tour-com-step="5">
                                <category-list :categories="categories" @click="toggleCategoryFilter"></category-list>
                            </div>
                        </div>
                        <div class="columns is-mutiline">
                            <div class="column is-5">
                                <div class="columns is-mutiline box minimal-horizontal-padding">
                                    <div class="column is-12 minimal-vertical-margin minimal-vertical-padding">
                                        <p class="subtitle is-5 minimal-vertical-margin">Search results:
                                            <a class="is-link is-pulled-right tooltip is-tooltip-top" data-tooltip="Quick add sentence!" @click="createSentence"><i class="fa fa-plus-circle is-size-5"></i></a>
                                        </p>
                                        <clip-loader v-if="favCommentsLoading"></clip-loader>
                                        <p v-if="filteredSentences.length==0 && !favCommentsLoading" class="has-text-centered">No sentences found. Please add new sentences!</p>
                                        <draggable element="div" class="scroll-y minimal-horizontal-padding" v-model="filteredSentences" v-bind:options="{group:{ name:'sentences',  pull:'clone', put:false }}">
                                            <div data-tour-com-step="6" class="card float-left column is-12 is-12-mobile clickable minimal-vertical-margin minimal-vertical-padding" v-scroll-to="'#filters'" v-for='(sentence, index) in filteredSentences' @click='addSentence(sentence)'>
                                                <div class="card-content is-paddingless">
                                                    <div class="columns is-hidden-desktop-only is-hidden-touch is-multiline minimal-vertical-margin minimal-vertical-padding">
                                                        <div class="column is-9 is-12-mobile content minimal-vertical-padding">
                                                            <p class="has-text-grey-dark is-size-6 multiline-text"> {{parseSentence(sentence)}} </p>
                                                        </div>
                                                        <div class="column is-3 is-12-mobile">
                                                            <span v-for='category in sentence.categories' >
                                                                <category-tag class="tooltip is-tooltip-left" :data-tooltip="category.name" :category="category" :fullWidth="true" :key="category.id"></category-tag>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="columns is-12 is-hidden-widescreen is-multiline minimal-vertical-margin minimal-vertical-padding">
                                                        <div class="column is-12 content minimal-vertical-padding">
                                                            <p class="has-text-grey-dark is-size-6 multiline-text"> {{parseSentence(sentence)}} </p>
                                                        </div>
                                                        <div class="column is-12">
                                                            <span v-for='category in sentence.categories'  >
                                                                <category-tag class="tooltip is-tooltip-left" :data-tooltip="category.name" :category="category" :fullWidth="true" :key="category.id"></category-tag>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </draggable>

                                    </div>
                                </div>
                            </div>
                            <div class="column is-7">
                                <div class="columns is-multiline box"  data-tour-com-step="7">
                                    <p class="subtitle is-5 minimal-vertical-margin">Need help? Click <a href="https://www.youtube.com/watch?v=P-5Jsheomp4&fbclid=IwAR1x40T3hqcMnzS1NCP1RH_dR3Tfp7pn4b0aE80HIIsg_gB8k1T3FOjQ0NA" target="_blank">here</a> to watch short tutorial</p>
                                    <draggable element="div" class="tags conjuncts column is-12 minimal-vertical-padding minimal-vertical-margin" v-model="helperArrays.joiners()"  v-bind:options="{group:{ name:'sentences',  pull:'clone', put:false }}">
                                        <span class="tag float-left is-light height-min-content zero-vertical-margin sentence-font-size" v-for="joiner in helperArrays.joiners()" @click='addSentence(joiner)'>{{joiner.text}}</span>
                                    </draggable>
                                    <div class="column is-12">
                                        <div class="message max-height-300">
                                            <div class="message-body content minimal-vertical-padding minimal-horizontal-padding comment-sentences">
                                                <a class="delete is-medium is-pulled-right" @click="clearChoosedSentences()"></a>
                                                <draggable element="div" v-bind:list="choosedSentences" :options="{group:{ name:'sentences'}}" @change ="generateComment" class="display-inline-block draggable max-height-300 field is-grouped is-grouped-multiline overflow-y-auto" >
                                                        <div class="tags float-left has-addons height-min-content minimal-horizontal-padding minimal-vertical-margin" v-for='(sentence, index) in choosedSentences' v-bind:key="index">
                                                            <sentence-tag :sentence="sentence" :text="parseSentence(sentence)" :key="index"></sentence-tag>
                                                            <a class="tag is-delete zero-vertical-margin" @click="deleteSentence(index)" ></a>
                                                        </div>
                                                </draggable>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="column is-12">
                                        <a class="button is-block is-primary" @click="showSaveModal = true">
                                            <span class="icon">
                                                  <i class="fa fa-star"></i>
                                            </span>                                        
                                            <span>Save as Template</span>
                                        </a>
                                    </div>
                                </div>
                                <div class="columns is-multiline box"  data-tour-com-step="8">
                                    <p class="subtitle is-5 minimal-vertical-margin">New Feedback:</p>
                                    <div class="column is-12 ">
                                        <pre class="editor-pre"><div @keyup.ctrl.67="onCopy" @contextmenu.prevent="$refs.ctxMenu.open" contenteditable="true" ref="editor" class="multiline-text editor"></div></pre>
                                        <span class="help has-text-centered">If your school doesn't allow you to copy/paste your feedback, you should install <strong>"Don't fuck with paste"</strong> extension for your browser</span>
                                        <span class="help has-text-centered"><a class="is-danger is-size-6" target="_blank" href="https://chrome.google.com/webstore/detail/dont-fuck-with-paste/nkgllhigpcljnhoakjkgaieabnkmgdkb?hl=en">Extension for Google Chrome</a>
                                        or <a class="is-danger is-size-6" target="_blank" href="https://addons.mozilla.org/en-US/firefox/addon/don-t-fuck-with-paste/">Extension for Firefox</a></span>
                                    </div>
                                    <div class="column">
                                        <a class="button is-block is-info"                                           
                                           @click="onCopy"
                                        >Copy</a>
                                    </div>
                                </div>
                            </div>
                        </div>                        
                    </div>
                </transition>
                <transition name="fade">
                    <div v-if="step == 2">
                        <div class="columns box"  data-tour-com-step="1">
                            <div class="column">
                                <span class='title is-5'>{{'How well did ' + (student.name == '' ? 'your student' : student.name) + ' perform today?'}}</span>
                                <p><star-rating class="is-pulled-left" inactive-color="#ababab" :star-size="30" :show-rating="false" @rating-selected="applyRatingFilter" :rating="searchRating"></star-rating>
                                       <span class="delete clear-star" @click="applyRatingFilter(0)"></span></p>
                            </div>
                        </div>
                        <div class="columns box is-multiline" v-if="!favCommentsLoading && (!filteredFavoriteComments || filteredFavoriteComments.length == 0)">
                            <div class="column has-text-centered">
                                <p class="title is-3" v-if="searchRating == 0">You still haven't added any templates</p>
                                <p class="title is-3" v-else>You don't have any templates with rating {{searchRating}}</p>
                            </div>
                        </div>
                        <div class="columns is-multiline" v-else>
                            <div class="column is-4-fullhd is-12-mobile is-6-tablet"  data-tour-com-step="2" v-for="(comment, index) in filteredFavoriteComments">
                                <div class="card  clickable" @click="loadSavedComment(comment)" v-scroll-to="'#tabs'">
                                    <header class="card-header min-height-100">
                                        <p class="card-header-title">{{comment.caption}} ({{comment.count > 1 ? comment.count + " times used" : comment.count + " time used"}})</p>
                                        <a class="card-header-icon">
                                            <star-rating inactive-color="#ababab" :star-size="20" :show-rating="false" :read-only="true" :rating="comment.score"></star-rating>
                                              <a class="delete is-small is-pulled-right" v-on:click="showDeleteModal($event, comment.id, index)"></a>
                                        </a>
                                    </header>
                                    <div class="card-content max-height-250">
                                        <div class="content has-text-justified">
                                            <p class="has-text-grey-dark" style="white-space: pre-wrap" v-html="comment.text"></p>
                                            <!--<time  class="has-text-grey-dark">{{comment.updated_at.date.split('.')[0]}}</time>-->
                                        </div>
                                    </div>                                                                     
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
                <transition name="fade">
                    <div v-show="step == 3">
                        <div class="columns is-multiline">
                            <div class="column is-4-fullhd is-12-mobile is-6-tablet" v-for="(comment, index) in historyComments">
                                <div class="card clickable" @click="loadSavedComment(comment)" v-scroll-to="'#tabs'">
                                    <header class="card-header">
                                        <p class="card-header-title">{{comment.updated_at.date.split('.')[0]}} ({{comment.count > 1 ? comment.count + " times used" : comment.count + " time used"}})</p>
                                        <a class="card-header-icon">
                                          <span class="icon">
                                            <i class="fa fa-history" aria-hidden="true"></i>
                                          </span>
                                        </a>
                                    </header>
                                    <div class="card-content max-height-250">
                                        <div class="content has-text-justified">
                                            <p class="has-text-grey-dark">{{comment.text}}</p>                                            
                                        </div>
                                    </div>                                                                     
                                </div>
                            </div>
                        </div>                    
                    </div>
                </transition>
            </div>
        </div>
        <clip-loader v-if="favCommentsLoading || historyCommentsLoading"></clip-loader>
        <div class="modal" v-bind:class="{'is-active': showSaveModal}">
            <div class="modal-background"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Save as Template</p>
                    <button class="delete" aria-label="close" @click="showSaveModal = false"></button>
                </header>
                <section class="modal-card-body">
                    <div class="field">
                        <span class="heading has-text-grey">How'd you like name this template?</span>
                        <bulma-input name="caption" v-model="comment.caption" rules="required" placeholder='e.g. Repeat student, Improved speaking...'/>
                    </div>
                    <div class="field">
                        <span class="heading has-text-grey">How well should student perform to get this feedback</span>
                        <star-rating inactive-color="#ababab" :star-size="30" :show-rating="false" @rating-selected="comment.score = $event" :rating="0"></star-rating>
                    </div>                    
                </section>
                <footer class="modal-card-foot has-text-right">
                    <loading-button v-bind:loading="saveCommentLoading" color="is-primary" @click="addComment(1)">Save</loading-button>
                    <button class="button is-danger is-pulled-right" @click="showSaveModal = false">Cancel</button>
                </footer>
            </div>
        </div>

        <create-sentence-modal v-if="categories.length>0" :categories="categories" :magicWords="magicWords" :showModal="showCreateSentenceModal" @onClose="showCreateSentenceModal = false" @onAdded="sentenceAdded" ></create-sentence-modal>


        <div class="modal" v-bind:class="{'is-active': showStudentsModal}">
            <div class="modal-background"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{student.provider_id}} - {{student.name}}</p>
                    <button class="delete" aria-label="close" @click="showStudentsModal = false"></button>
                </header>
                <section class="modal-card-body">
                    <div class="columns is-multiline">
                        <div class="column is-12" v-for="(comment, index) in studentComments">
                            <div class="card  clickable" @click="() => {loadSavedComment(comment); showStudentsModal = false;}" v-scroll-to="'#tabs'">
                                <header class="card-header min-height-100" v-if="comment.favorite == 1">
                                    <p class="card-header-title">{{comment.caption}}</p>
                                    <a class="card-header-icon">
                                        <star-rating inactive-color="#ababab" :star-size="20" :show-rating="false" :read-only="true" :rating="comment.score"></star-rating>
                                        <!--<a class="delete is-small is-pulled-right" v-on:click="showDeleteModal($event, comment.id, index)"></a>-->
                                    </a>
                                </header>
                                <header class="card-header" v-else>
                                    <p class="card-header-title">{{comment.updated_at.date.split('.')[0]}}</p>
                                    <a class="card-header-icon">
                                          <span class="icon">
                                            <i class="fa fa-history" aria-hidden="true"></i>
                                          </span>
                                    </a>
                                </header>
                                <div class="card-content max-height-250">
                                    <div class="content has-text-justified">
                                        <p class="has-text-grey-dark">{{generateCommentFromSentences(comment.sentences)}}</p>
                                        <time  class="has-text-grey-dark">{{comment.updated_at.date.split('.')[0]}}</time>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <footer class="modal-card-foot has-text-right">
                    <button class="button is-info is-pulled-right" @click="showStudentsModal = false">Ok</button>
                </footer>
            </div>
        </div>

        <context-menu id="context-menu" ref="ctxMenu">
            <li @click="onCopy"><i class="fa fa-clipboard"></i> <span>Copy</span></li>
        </context-menu>
        <vue-tour @onChangeStep="onChangeStep" ref="tour" :active="tourActive" :steps="tourSteps" btnDoneText="Next page" @onPreviousStep="prevStep" @onNextStep="nextStep" @onNextPage="nextPage" @onSkip="skipTour" @onStart="startTour"></vue-tour>
    </div>
</template>
<script>
import gender from 'gender-guess'

export default {
    name: 'comments',
    components: {},
    data() {
        return {
            loading : false,
            showSaveModal: false,
            showStudentsModal: false,
            showCreateSentenceModal: false,
            showQuickGuide: true,
            saveCommentLoading: false,
            me: {},
            sentence:'',
            sentences:[],
            magicWords:[],
            allMagicWords:[],
            activeMagicWords:[],
            magicWordsData:{},
            activeMagicWordsData:{},
            step:2,
            searchRating:0,
            filteredSentences: [],
            categories: [],
            categoryFilters: [],
            choosedSentences:[],
            searching: false,
            favoriteComments: [],
            filteredFavoriteComments: [],
            historyComments: [],
            comment: { text: '', html: '', caption: '', favorite: 0, score:1},
            historyPage: 1,
            historyPagination: 6,
            favPage: 1,
            favPagination: 6,
            hasFavMore: false,
            hasHistoryMore: false,
            historyCommentsLoading: false,
            favCommentsLoading: false,
            selectedLesson : null,
            lessons : [],
            lessonsPID : [],
            lesson : {name: '', provider_id: '', words: '', additionalData:{}},
            lessonError: null,
            studentError:null,
            searchLesson : false,
            searchLessonPID : false,
            student : {name: '', nick: '', provider_id: '', gender: 'male'},
            studentComments: [],
            lessonFormatHint: '',
            lessonPlaceholder: '',
            wordsRequired: false,
            studentRequired: false,
            tourSteps: [
                {
                    element: "[data-tour-com-step='1']",
                    text: '<p class="has-text-justified">How would you rate your <strong>student’s</strong>   <em>performance</em> in today’s <strong> class</strong>? Select <em>any</em> number of starts to preview premade <strong>templates</strong>.  <br><br><em>*You can also create <strong> custom templates</strong> and save them as your own for future use </em> </p>'
                },
                {
                    element : "[data-tour-com-step='2']",
                    text : '<p class="has-text-justified">Let’s take <strong> this</strong> one for example. Please <strong>click</strong> on this <strong>template</strong> to <strong>select</strong> it! </p>',
                },
                {
                    element: "[data-tour-com-step='3']",
                    text: '<p class="has-text-justified"><strong>Lesson ID</strong> and <strong>Student ID</strong> numbers can <em>usually </em> be found on your school’s webpage. Every <em> student</em> and <em>lesson</em> have a <em>unique</em> <strong>ID </strong> number attached to them, search for that and <strong>copy</strong> it here. <br><br><em>*If you can’t find it just leave it blank and fill out the <strong>Student</strong> name filed instead. </em> </p>'
                },
                {
                    element: "[data-tour-com-step='4']",
                    text: '<p class="has-text-justified">Try typing any <strong>keyword</strong> or a part of a sentence and all matching <strong>sentences</strong> will be displayed below.<br><br><em>*Popular keywords are: <strong>Learn</strong> ; <strong>Vocabulary</strong> ; <strong>Speaking</strong> ; <strong>Improving</strong> </em>  </p>'
                },
                {
                    element: "[data-tour-com-step='5']",
                    text: '<p class="has-text-justified"><em>Another</em> way to <strong>sort</strong> sentences is by category name. Try clicking on any <strong>category </strong> and relevant <strong>sentences</strong> will be displayed below. <br><br><em> *To add <strong>new </strong> categories or <strong>re-order</strong> the way they are listed here, please visit <strong class="has-text-primary"> Collection – Categories </strong> </em></p>'
                },
                {
                    element: "[data-tour-com-step='6']",
                    text: '<p class="has-text-justified">Let’s use <strong>this</strong> one.  Simply <strong>click</strong> on this sentence and it will be <en>added</en> to your <strong>feedback</strong>.</p>'
                },
                {
                    element : "[data-tour-com-step='7']",
                    text : '<p class="has-text-justified">This is your <strong>canvas</strong>; Try <em> Dragging</em> the <strong>sentences</strong> to <em>change</em> their position in the text or use <strong>conjunctions</strong> to <em>connect</em> them. To <strong>remove</strong> a sentence, click the little <strong>x</strong> in the top right corner. <br><br><em>*Available conjunctions are: <strong>And</strong> ; <strong>But</strong> ; <strong>However</strong> ; <strong>Even</strong> ;<strong> Additionally</strong> ; <br>They are located above. </em></p>'
                },
                {
                    element: "[data-tour-com-step='8']",
                    text: '<p class="has-text-justified"><strong class="has-text-primary"> Congratulations</strong>, you created your first <strong> feedback</strong>! Keep it up, you’re a <em>natural</em>!    </p>'
                },
            ],
        }
    },
    created(){
        this.loadPageData();
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
    },
    mounted(){
        window.addEventListener('scroll', this.handleScroll);
        if (document.addEventListener) {
            document.addEventListener('extension-event', this.catchExtensionEvent, false);
        } else {
            document.attachEvent('extension-event', this.catchExtensionEvent);
        }
    },
    methods: {
        magicWordsDataChanged(){
            this.student = JSON.parse(JSON.stringify(this.student));
            this.generateComment();
        },
        loadPageData(){
            this.favCommentsLoading = true;
            this.historyCommentsLoading = true;
            let self = this;
            this.pageRepo.getCommentsData(this.$route.path).then(response => {
                let data = response.data.data;

                //prepare profile
                this.me = data.me;
                _.forEach(data.nonStaticMagicWords, function(value) {
                    self.magicWordsData[value.name] = "";
                });

                this.allMagicWords = data.nonStaticMagicWords;
                this.magicWords = data.magicWords;

                //prepare categories
                this.categories = data.categories;
                this.category = this.categories[0].id;

                //prepare sentences
                this.sentences = data.sentences;
                if(this.categories.length > 0) {
                    this.sentences = this.helper.updateSentenceColor(this.sentences, this.categories);
                }
                this.filteredSentences = JSON.parse(JSON.stringify(this.sentences));

                if(data.tour.show) {
                    this.tourActive = true;
                }

                //prepare favorite comments
                _.forEach(data.favoriteComments.data, function(value) {
                    let favCat = value;
                    favCat.sentences = self.helper.updateSentenceColor(favCat.sentences, self.categories);
                    self.favoriteComments.push(value);
                });
                this.hasFavMore = this.favPage < data.favoriteComments.meta.pagination.total_pages;
                this.filteredFavoriteComments = JSON.parse(JSON.stringify(this.favoriteComments));
                this.favCommentsLoading = false;

                //prepare history comments
                _.forEach(data.historyComments.data, function(value) {
                    let hisCat = value;
                    hisCat.sentences = self.helper.updateSentenceColor(hisCat.sentences, self.categories);
                    self.historyComments.push(hisCat);
                });

                this.hasHistoryMore = this.historyPage < data.historyComments.meta.pagination.total_pages;
                this.historyCommentsLoading = false;

            }).finally(() => {
                this.favCommentsLoading = false;
                this.historyCommentsLoading = false;
            });
        },
        startTour(){
          this.step = 2;
          this.tourActive = true;
        },
        selectSchool(school){
          this.me.profile.school = school;

          if(this.lesson.provider_id && this.lesson.provider_id.length >= 3){
              this.findLesson();
          }
          else if(this.lesson.name && this.lesson.name.length >= 3){
              this.searchLessons();
          }

          if(this.student.provider_id && this.student.provider_id.length >= 3){
              this.findStudent();
          }
        },

        onLessonTypePID:_.debounce(function(value){
            this.lesson.provider_id = value;

            if(value && value.length > 0){
                if(this.me.profile.school.name === this.MAGIC_EARS.name){
                    //console.log(this.MAGIC_EARS.name);
                    if(!this.meLessonFormat(value)){
                        this.lessonError = "Wrong format!";
                        return;
                    }
                }else if(this.me.profile.school.name === this.VIPKID.name){
                    //console.log(this.VIPKID.name);
                    if(!this.vkLessonFormat(value)){
                        this.lessonError = "Wrong format!";
                        return;
                    }
                }
                this.findLesson();
            }
        },800),

        onLessonType(value){
            this.lesson.name = value;
            if (value && value.length >= 3) {
                this.searchLessons();
            }else {
                this.lesson.name = value;
            }
        },
        searchLessons(){
            this.searchLesson = true;
            this.lessons = [];
            this.lessonRepo.search({name: this.lesson.name, school_id:this.me.profile.school.id}).then(response => {
                let data = response.data.data;
                if(Array.isArray(data) && data.length>0){
                    this.lessons = data;
                    //this.lesson = data[0];
                }
                else if(!Array.isArray(data) && data != null){
                    this.lessons = [data];
                    //this.lesson = data;
                }else{
                    this.lessonsPID = [];
                }
                this.populateAllFieldsWithMW();
                this.searchLesson = false;
            }).catch((response) => {
                this.searchLesson = false;
                return Promise.reject(response);
            });
        },
        findLesson(){
            this.lessonError = null;
            this.searchLessonPID = true;
            this.lessonsPID = [];
            //console.log('findLesson');
            this.lessonRepo.search({'provider_id': this.lesson.provider_id, school_id:this.me.profile.school.id}).then(response => {
                let data = response.data.data;
                if(Array.isArray(data) && data.length>0){
                    this.lessonsPID = data;
                    this.lesson = data[0];
                }
                else if(!Array.isArray(data) && data != null){
                    this.lessonsPID = [data];
                    this.lesson = data;
                }else{
                    this.lessonsPID = [];
                    this.lessonError = "Looks like we don't have this lesson in our database, please fill out the Magic Words manually.";
                }
                this.searchLessonPID = false;
                this.populateAllFieldsWithMW();
            }).catch((response) => {
                this.searchLessonPID = false;
                this.lessonError = "Looks like we don't have this lesson in our database, please fill out the Magic Words manually.";
            });
        },
        onLessonChanged(lesson){
            this.lesson = lesson;
            //this.stopPropagation = true;
            //console.log('onLessonChanged');
        },
        onLessonChangedPID(lesson){
            this.lesson = lesson;
        },

        findStudent(){
            this.studentError = null;

            this.studentRepo.search({'provider_id': this.student.provider_id, school_id:this.me.profile.school.id}).then(response => {
                this.student = response.data.data;
                this.getStudentComments(response.data.data.id);
            }).catch((response) => {
                this.studentError = "Looks like we dont't have this student in our database, please fill out name and gender manually.";
                this.student.id = undefined;
                this.student.name = "";
                this.student.nick = "";
                this.student.gender = 'male';
                this.studentComments = [];
            });
        },
        getStudentComments(student_id){
            this.studentComments = [];
            this.userRepo.studentComments(student_id).then(response => {
                this.studentComments = response.data.data;
            });
        },
        handleScroll(e){
            var d = document.documentElement;
            var offset = d.scrollTop + window.innerHeight;
            var height = d.offsetHeight;

            if (offset >= height - 220) {
                if(this.step == 2){
                    this.nextFavPage();
                }
                else if(this.step == 3){
                    this.nextHistoryPage();
                }
            }
        },
        catchExtensionEvent(e){
            let self = document.querySelector("#comments").__vue__;
            self.student.name = e.detail.student;
            self.lesson.words = e.detail.words;

            self.$forceUpdate();
        },
        changeStep(step){
            this.step = step;
        },
        applyRatingFilter(rating){
            if(rating !== undefined){
              this.searchRating = rating;
            }
            this.favPage = 1;
            this.loadFavComments(true);
    /*        if(this.favoriteComments == null || this.favoriteComments.length == 0){
                return;
            }

            this.filteredFavoriteComments = JSON.parse(JSON.stringify(this.favoriteComments));

            if(this.searchRating != 0){
                let self = this;
                this.filteredFavoriteComments = _.filter(this.filteredFavoriteComments, function(comment) {
                    return comment.score == self.searchRating;
                });
            }*/
        },
        toggleCategoryFilter(categoryFilters){

              this.categoryFilters = categoryFilters;

              this.applyFilters();
          },
        applyFilters(direction = 'desc'){
            let toKeep = [];
            this.filteredSentences = JSON.parse(JSON.stringify(this.sentences));

            if(this.categoryFilters.length > 0){
                for(var j=0;j<this.filteredSentences.length;j++){
                    let sentence = this.filteredSentences[j];
                    let hasCategory = false;
                    for(var i=0;i<this.categoryFilters.length;i++){
                        let category = this.categoryFilters[i];
                        if(sentence.categories){
                            for(var k=0;k<sentence.categories.length;k++){
                                if(category.id == sentence.categories[k].id){
                                    hasCategory = true;
                                    break;
                                }
                            }
                        }
                    }
                    if(hasCategory === true){

                        toKeep.push(sentence);
                    }
                }

                this.filteredSentences = toKeep;
            }

            if(this.sentence != ''){
                this.filteredSentences = this.filteredSentences.filter(sentence => {
                    return sentence.text.toLowerCase().includes(this.sentence.toLowerCase())
                })
            }

            this.filteredSentences = _.orderBy(this.filteredSentences, function(e) {

                if(e.categories != null && e.categories.length > 0){
                    return e.categories[0].id;
                }

                return e.id;
            }, [direction]);
        },
        genderChanged(){
            this.generateComment();
        },
        clearChoosedSentences(){
            this.choosedSentences = [];
            let self = this;
            _.forEach(this.activeMagicWords, function(item) {
                self.magicWordsData[item.name] = ""
            });
            this.activeMagicWords = [];
            this.generateComment();
        },
        addSentence(sentence){
            this.choosedSentences.push(sentence);
            let self = this;
            this.populateFieldsWithMW(sentence);
            if(this.tourActive) {
                this.$refs.tour.nextStep();
            }
            this.generateComment();
        },

        populateFieldsWithMW(sentence){
            let self = this;
            _.forEach(this.allMagicWords, function(item) {
                if(sentence.text.includes(item.alias)){
                    self.activeMagicWords.indexOf(item) === -1 ? self.activeMagicWords.push(item) : '';
                    self.magicWordsData[item.name] = self.lesson && self.lesson.additionalInfo && self.lesson.additionalInfo[item.name] && self.lesson.additionalInfo[item.name] != '' ? self.lesson.additionalInfo[item.name] : self.magicWordsData[item.name];
                }
            });
        },

        populateAllFieldsWithMW(){
            let self = this;
            _.forEach(this.choosedSentences, function(sentence) {
                self.populateFieldsWithMW(sentence);
            });
        },

        deleteSentence(index){
            let self = this;
            this.choosedSentences.splice(index, 1);
            this.activeMagicWords = this.activeMagicWords.filter(item => self.filterMagicWords(item));
            this.generateComment();
        },
        filterMagicWords(magicWord){
            if((this.choosedSentences.filter(item => item.text.includes(magicWord.alias)).length > 0) ){
                return true;
            }
            this.magicWordsData[magicWord.name] = "";
            return false;
        },
        loadSavedComment(comment){
            this.choosedSentences = [];
            let sentences = this.helper.updateSentenceColor(comment.sentences, this.categories);
            let self = this;
            this.activeMagicWords = [];
            _.forEach(sentences, function(sentence) {
                self.choosedSentences.push({
                    id: sentence.id,
                    text: sentence.text,
                    categories:  sentence.categories
                });
                self.populateFieldsWithMW(sentence);
                if(sentence.pivot.joiner != ""){

                    _.forEach(self.helperArrays.joiners(), function(joiner) {
                        if(sentence.pivot.joiner == joiner.text){
                            self.choosedSentences.push(joiner);
                        }
                    });
                }
            });
            this.generateComment();
/*            if(this.student.name && this.student.name != ''){
                this.generateComment();
            }
            else{
                this.comment.html = this.$refs.editor.innerText = this.$refs.editor.innerHTML = this.comment.text = comment.text;
            }*/

            this.step = 1;
            if(this.tourActive) {
                this.$refs.tour.nextStep();
            }

        },
        parseSentence(sentence, wasJoiner = false){
            let self = this;
            let filtered = this.helper.parseSentence(sentence, wasJoiner , self.student.gender);

            if(self.student.name != ""){
                filtered = filtered.replace(/{{student.name}}/gi, self.student.name);
            }

            if(self.student.nick != ""){
                filtered = filtered.replace(/{{student.nick}}/gi, self.student.nick);
            }
            _.forEach(this.allMagicWords, function(item) {
                if(self.magicWordsData[item.name] != ""){
                    filtered = filtered.replace(item.alias, self.magicWordsData[item.name]);
                }
            });

            if(self.lesson.words != ""){
                filtered = filtered.replace(/{{words}}/gi, self.lesson.words);
            }

            if(self.me.profile != null) {
                if (self.me.profile.name != "" && self.me.profile.name != null) {
                    filtered = filtered.replace(/{{teacher.name}}/gi, self.me.profile.name);
                }

                if (self.me.profile.nick != "" && self.me.profile.nick != null) {
                    filtered = filtered.replace(/{{teacher.nick}}/gi, self.me.profile.nick);
                }
            }

            return filtered;
        },
        generateComment(){
            //console.log('generateComment');
            this.comment.text = "";
            let self = this;
            let wasJoiner = false;
            _.forEach(this.choosedSentences, function(sentence) {
                if(!sentence.isJoiner){
                    if(self.comment.text != ""){
                        self.comment.text += " ";
                    }
                    self.comment.text += self.parseSentence(sentence, wasJoiner);
                }
                else{
                    let comment = self.comment.text;
                    if(comment.substring(comment.length-1) == "." || comment.substring(comment.length-1) == "!"
                        || comment.substring(comment.length-1) == "," || comment.substring(comment.length-1) == "?")
                    {
                        comment = comment.substring(0, comment.length-1);
                    }

                  self.comment.text = comment + sentence.value;
                }

              wasJoiner = sentence.isJoiner;
            });

            this.comment.html = this.$refs.editor.innerText = this.$refs.editor.innerHTML = this.comment.text;
          },
        generateCommentFromSentences(sentences){
            //console.log('generateCommentFromSentences');
            let result = "";
            let self = this;
            let wasJoiner = false;
            _.forEach(sentences, function(sentence) {

              if(!sentence.isJoiner){

                  if(result != ""){
                      result += " ";
                  }

                  result += self.parseSentence(sentence, wasJoiner);
              }
              else{
                  let comment = result;
                  if(comment.substring(comment.length-1) == "." || comment.substring(comment.length-1) == "!"
                      || comment.substring(comment.length-1) == "," || comment.substring(comment.length-1) == "?")
                  {
                      comment = comment.substring(0, comment.length-1);
                  }

                  result = comment + sentence.value;
              }

              wasJoiner = sentence.isJoiner;
            });

            return result;
          },
        addComment(isFav){

            this.comment.favorite = isFav;
            this.comment.count = 1;
            this.comment.text = this.helper.prepareOriginalTextForServer(this.$refs.editor.innerText, this.student, this.lesson, this.me.profile);
            this.saveCommentLoading = true;

            let self = this;
            var lesson = Object.assign({}, this.lesson);
            lesson.additionalInfo = {};
            _.forEach(this.activeMagicWords, function(item) {
                if(self.magicWordsData[item.name] != null){
                    lesson.additionalInfo[item.name] = self.magicWordsData[item.name];
                }
            });
            let data = {
                comment : this.comment,
                sentences : this.helper.prepareSentencesForServer(this.choosedSentences),
                lesson : lesson,
                student : this.student,
                school_id : this.me.profile.school.id
            };
            this.commentRepo.store(data).then(response => {
                let comment = response.data.data;
                this.saveCommentLoading = false;
                this.comment.id = comment.id;
                this.comment.caption = '';
                this.showSaveModal = false;
                this.loadFavComments(true);
                this.loadCommentsHistory(true);
            }).catch((response) =>{
                this.saveCommentLoading = false;
                return Promise.reject(response);
            });
        },

        nextFavPage(){
            if(this.hasFavMore){
                this.hasFavMore = false;
                this.favPage += 1;
                this.loadFavComments();
            }
        },
        nextHistoryPage(){
            if(this.hasHistoryMore){
                this.hasHistoryMore= false;
                this.historyPage += 1;
                this.loadCommentsHistory();
            }
        },
        loadFavComments(reset){
            let self = this;
            this.favCommentsLoading = true;
            let searchData = null;
            if(this.searchRating !== 0){
                searchData = {
                    'search' : [
                        {'score' : this.searchRating},
                    ]
                }
            }

            if(reset) {
                this.favPage = 1;
                this.favoriteComments = [];
            }

            this.userRepo.favComments(searchData, this.favPage, this.favPagination).then(response => {

                _.forEach(response.data.data, function(value) {
                    let favCat = value;
                    favCat.sentences = self.helper.updateSentenceColor(favCat.sentences, self.categories);
                    self.favoriteComments.push(value);
                });


                this.hasFavMore = this.favPage < response.data.meta.pagination.total_pages;

                /*if(this.favoriteComments.length == 0 && this.step != 1){
                    this.step = 1;
                }*/

                this.filteredFavoriteComments = JSON.parse(JSON.stringify(this.favoriteComments));

                this.favCommentsLoading = false;

            }).finally(() => {
                this.favCommentsLoading = false;
            });
        },
        loadCommentsHistory(reset){
            let self = this;
            this.historyCommentsLoading = true;
            if(reset) {
                this.historyPage = 1;
                this.historyComments = [];
            }
            this.userRepo.commentsHistory(this.historyPage, this.historyPagination).then(response => {
                _.forEach(response.data.data, function(value) {
                    let hisCat = value;
                    hisCat.sentences = self.helper.updateSentenceColor(hisCat.sentences, self.categories);
                    self.historyComments.push(hisCat);
                });

                this.hasHistoryMore = this.historyPage < response.data.meta.pagination.total_pages;
                this.historyCommentsLoading = false;
            }).finally(() => {
                this.historyCommentsLoading = false;
            });
        },
        onCopy(){
            let proceed = true;
            let message = "You didn't fill in student's name!";
            let commentText = this.$refs.editor.innerText;
            this.$validator.validateAll().then((result) => {
                proceed = result;
            });


            if(commentText.indexOf('{{student.name}}') != -1){
                proceed = false;
                this.studentRequired = true;
            }

            if(commentText.indexOf('{{words}}') != -1){
                message = "You didn't fill in lesson vocabulary!";
                proceed = false;
                this.wordsRequired = true;
            }
            
            let self = this;
            if(proceed) {
                _.forEach(this.activeMagicWords, function (mw) {
                    if (commentText.indexOf(mw.alias) != -1) {
                        proceed = false;
                        message = "Empty Magic Words detected! Please fill out all Magic Words.";
                    }
                });
            }

            if(!proceed){
                this.$swal({
                    title: 'Ooops...',
                    text: message,
                    type: 'warning',
                    confirmButtonColor: '#3273dc',
                    cancelButtonColor: '#ff3860',
                    confirmButtonText: 'Ok, got it!'
                }).then((result) => {
                        if (result.value) {
                            let self = this;
                            setTimeout(function(){
                                self.$scrollTo(self.$refs.leesonInfo);
                            }, 400);
                        }
                });
                
                return;
            }

            this.$copyText(commentText).then(function (e) {
                self.$toast.info("Feedback successfully copied!");
                self.addComment(0);
            });


        },
        showDeleteModal($e, id, index){
            $e.stopPropagation();
            let self = this;
            this.$swal({
              title: 'Are you sure?',
              text: "This will delete comment permanently and you won't be able to revert this!",
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3273dc',
              cancelButtonColor: '#ff3860',
              confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
              if (result && result.value) {
                  self.deleteFavComment(id, index);
              }
            }).catch((result) => {
    });

        },
        deleteFavComment (id, index) {
          this.commentRepo.delete(id).then(response => {
              this.favoriteComments.splice(index, 1);
              this.applyRatingFilter();
              this.$swal(
                  'Deleted!',
                  'Comment has been deleted.',
                  'success'
              )
          });
        },
        updateHtml(data){
            this.comment.html = data;
        },
        storeLesson(){
            if(this.lesson.id && this.lesson.name && this.lesson.words) {
                this.lessonRepo.store(this.lesson).then(response => {
                    //console.log(response.data);
                });
            }
        },

        createSentence(){
            //console.log('createSentence');
            this.showCreateSentenceModal = true;
        },
        sentenceAdded(sentence){
            this.sentences = sentence.concat(this.sentences);
            this.applyFilters();
        },
    },
    computed: {

    },
    
    watch: {
        sentence: _.debounce(function(value){
            if(value.length >= 3){
                this.searching = true;
                this.applyFilters();
                this.searching = false;
            }
            else if(value == ''){
                this.applyFilters();
            }
        }, 800),

        'student.name':_.debounce(function(value){
            if(value){
                this.studentRequired = false;
            }
            let guess = gender.guess(this.student.name);
            if(guess && guess.gender != null && guess.confidence != null && guess.confidence > 0.6 && this.student && !this.student.id){
                this.student.gender = guess.gender == "M" ? "male" : "female";
            }

            this.generateComment();

        }, 800),
        
        'lesson.words': function(value){
            console.log(value);
            if(value){
                this.wordsRequired = false;
            }
        },

/*
        'lesson':_.debounce(function(value){
            console.log('Changed lesson');
          this.generateComment();
        }, 800),
*/


        lesson: {
            deep: true,
            handler: _.debounce(function(value){
                //console.log('Changed lesson');
                this.generateComment();
            }, 800)
        },

        'student.nick':_.debounce(function(value){
          this.generateComment();
        }, 800),
        'me.profile.school':function(value){
            this.lessonFormatHint = '';
            this.lessonPlaceholder = "Copy it from your schools website";
            //console.log('CHANGED SCHOOL');
            if(value){
                if(value.name === this.MAGIC_EARS.name){
                    this.lessonFormatHint = 'Example: L1-U1-L1, L5-U101-L8,...';
                    this.lessonPlaceholder = 'e.g. 1-1-1 or L1-U1-L1';
                }else if(value.name === this.VIPKID.name){
                    this.lessonFormatHint = 'Example: MC-L1-U1-LC1-1, T1-U4-LC1-L1,...';
                    this.lessonPlaceholder = 'e.g. MC-L1-U1-LC1-1';
                }
            }
        },
        'student.provider_id':_.debounce(function(value){
            if(this.validURL(value)){
                let studentId = this.getStudentId(value);
                if(studentId){
                    this.student.provider_id = studentId;
                }
            }
            
            if(value && value.length > 0){
              this.findStudent();
            }
        }, 800),
    
  }
  
}

</script>

<style lang="css" scoped>


@keyframes click-wave {
  0% {
    height: 20px;
    width: 20px;
    opacity: 0.35;
    position: relative;
  }
  100% {
    height: 30px;
    width: 30px;
    margin-left: -5px;
    margin-top: -5px;
    opacity: 0;
  }
}

.option-input {
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  -o-appearance: none;
  appearance: none;
  position: relative;
  top: 4.33333px;
  right: 0;
  bottom: 0;
  left: 0;
  height: 20px;
  width: 20px;
  transition: all 0.15s ease-out 0s;
  background: #cbd1d8;
  border: none;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  margin-right: 0.5rem;
  margin-left: 0.5rem;
  outline: none;
  position: relative;
  z-index: 11;
}
.option-input:hover {
  background: #9faab7;
}
.option-input:checked {
  background: #00d1b2!important;
}
.option-input:checked::before {
  height: 20px;
  width: 20px;
  position: absolute;
  content: '✔';
  display: inline-block;
  font-size: 13.3333px;
  text-align: center;
  line-height: 20px;
}
.option-input:checked::after {
  -webkit-animation: click-wave 0.65s;
  -moz-animation: click-wave 0.65s;
  animation: click-wave 0.65s;
  background: #00d1b2!important;
  content: '';
  display: block;
  position: relative;
  z-index: 10;
}
.option-input.radio {
  border-radius: 50%;
}
.option-input.radio::after {
  border-radius: 50%;
}
.option-input span {
    padding-top: 10px;
}

.draggable{
    min-height: 70px;
}

.card-content{
    padding-top:2px;
    padding-bottom:2px;
}

.max-height-250{
    height: 250px;
    max-height: 250px;    
    overflow-y: auto; 
}

.max-height-300{
    height: 300px;
    max-height: 300px;
}

.height-auto{
    height:auto;
}

.height-min-content{
    height: min-content;
}

.clear-star{
    margin-top: 7px;
    margin-left: 5px;
}

.float-left{
    float: left;
}

.display-block{
    display: block;
}

.sentence-font-size{
    font-size: 0.95rem !important;
}

.min-height-100{
    min-height: 100px;
    height: fit-content;
}

.editor{
    min-height: 300px;
    overflow: auto;    
    font-size: 14px;
    line-height: 1.5;
    background-color: #fff;
    color: #333;    
    overflow: hidden;
    text-align: justify;    
    font-family: 'Pfdintextpro';
    white-space: pre-line !important;
    border:none;
    width: 100% !important;
    max-width: 100% !important;
    padding: 0px;
}

.editor:active, .editor:focus{
    border:none;     
    outline:none;
}
.editor-pre{
    border: 1px solid #ddd;
    text-align: left;
    border-radius: 5px;
    padding: 10px;   
    min-height: 300px;
    font-size: 14px;
    line-height: 1.5;
    background-color:transparent;    
}
.display-initial{
    display: initial;
}

.display-inline-block{
    display: inline-block;
}

.conjuncts{
    height: 18px;
}
.ctx-menu.ctx-menu-left li{
    padding-left: 10px;
    line-height: 24px;
}

.ctx-menu.ctx-menu-left li:hover{
    cursor: pointer;
    color: white;
    background-color: #00d1b2;
}

.ctx-menu.ctx-menu-left li span{
    padding-left: 5px;
}

.overflow-y-auto{
    overflow-y: auto;
}

.comment-sentences{
    background-color: whitesmoke;
    border: none
}

.comment-sentences .field.is-grouped.is-grouped-multiline:last-child{
    margin-bottom: 0.25rem
}

a.is-danger{
    color: rgb(255, 56, 96);
}

.tooltip.is-tooltip-bottom:focus::before, .tooltip.is-tooltip-bottom:hover::before, .tooltip.is-tooltip-bottom.is-tooltip-active::before {
transform: translate(-50%, 0.5rem);
min-width: 300px;
text-align: justify;
}

@media screen and (max-width: 768px){
    .tabs ul{
        width: 100%;
        display: block;
    }
    .tabs li{
        width: 100%;
    }

    .tabs li a{
        height: 60px;
    }

}
    .modal{
        z-index: 999 !important;
    }


</style>



// WEBPACK FOOTER //
// src/pages/Comments.vue